import script from "./memoriallist.vue?vue&type=script&setup=true&lang=ts"
export * from "./memoriallist.vue?vue&type=script&setup=true&lang=ts"

import "./memoriallist.vue?vue&type=style&index=0&id=590be4dc&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590be4dc"]])

export default __exports__